  // GA4 search_completed event
  document.addEventListener('click', function(event) {   
    if (event.target.matches('button.search__button.field__button.header-search-cta') || event.target.matches('button.search__button.field__button.header-search-cta svg.icon.icon-search')) {     
      var search_text= document.querySelector('form.search.search-modal__form input#Search-In-Modal').value;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        "event": "search_completed",
        'category': 'text_search',
        'name': search_text
      });
    }
  });

  // GA4 Login event when user login successful
  const customerId = theme.setting.customerId;    
  if (customerId && localStorage.getItem('login_event')) {
    localStorage.removeItem('login_event');
    localStorage.setItem("login_status", true);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "sign_in",
      'category': 'sign_in',
      'user_id': customerId,
      'action': 'Successful'
    });
    localStorage.setItem("userId", customerId);
  }

  // GA4 Login event when user login unsuccessful
  if (customerId == "" && localStorage.getItem('login_event')) {
    localStorage.removeItem('login_event');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "sign_in",
      'category': 'sign_in',
      'action': 'Unsuccessful'
    });

  }

  if (customerId && localStorage.getItem('login_status')) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "logged_in",
      'category': 'sign_in',
      'user_id': customerId,
      'login_status': 'logged_in'
    });

  }else{
    var userId= localStorage.getItem('userId');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "logged_in",
      'category': 'sign_in',
      'user_id': userId,
      'login_status': 'not_logged_in'
    });
    
  }